import type { Locale } from '#i18n'
import { normalizeSlug } from '~/utils/slug'

export default function useCategoryI18nReverse(i18nKeyPrefix: string) {
  const { t } = useI18n()
  function findByNormalizedTranslation(options: string[], search: string) {
    const normalizedSearch = normalizeSlug(search)
    return options.map(option => [normalizeSlug(t(i18nKeyPrefix + option)), option]).find(([translation]) => translation === normalizedSearch)?.[1]
  }
  function translateNormalized(option: string, locale?: Locale) {
    return normalizeSlug(translate(option, locale))
  }
  function translate(option: string, locale?: Locale) {
    return locale ? t(i18nKeyPrefix + option, {}, { locale }) : t(i18nKeyPrefix + option)
  }
  return {
    findByNormalizedTranslation,
    translateNormalized,
    translate,
  }
}
